import { Roles } from '../../../../shared/constants'

export default () => ({
  path: 'historical',
  name: 'operations-historical',
  component: () => import(/* webpackChunkName: "operations-historical" */ '../../../views/Operations/OperationsHistorical'),
  meta: {
    title: 'Historical',
    allowedUserRoles: [Roles.RADAR_OPS_LEGACY, Roles.RADAR_OPS],
  },
})
